// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading__24W05","fadeinphoto":"fadeinphoto__L1y6z","emoji":"emoji__3f9e5"};


//////////////////
// WEBPACK FOOTER
// ./components/loading/style.css
// module id = /dON
// module chunks = 14